module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_japones.673fe9a3.jpg";